import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

interface FieldProps {
  label?: ReactNode;
  required?: boolean;
  error?: ReactNode;
  hint?: ReactNode;
  className?: string;
  htmlFor?: string;
  children: ReactNode;
}

export function Field({ label, required, error, hint, className, htmlFor, children }: FieldProps) {
  return (
    <div className={cn('ds-field', className)}>
      {label && (
        <label className="ds-field-label" htmlFor={htmlFor}>
          {label}
          {required && <span className="req">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <span className="ds-field-error">{error}</span>
      ) : hint ? (
        <span className="ds-field-hint">{hint}</span>
      ) : null}
    </div>
  );
}
